import React from "react"
import { Container, Row, Col } from "react-bootstrap"

import { Link } from "gatsby"
import { LazyLoadComponent } from "react-lazy-load-image-component"
import { StaticImage } from "gatsby-plugin-image"

export default function AboutUs() {
  return (
    <section id="about" className="about-section">
      <div className="scrolldown text-center">
        <Link to="/#about">
          <div class="scroll-down"></div>
        </Link>
      </div>
      <Container>
        <Row>
          <Col className="mx-auto">
            <div className="about-content text-center text-white">
              <h2 className="section-title">
                FLUO is a Conscious Lifestyle Brand in alignment with how
                universal forces flow.
              </h2>
              <div className="d-flex flex-wrap align-items-center justify-content-center">
                <Link
                  to="/rally"
                  className="cta text-uppercase m-2"
                  aria-label="link"
                >
                  We’re here to Rally
                </Link>
                <Link
                  to="/belief"
                  className="cta text-uppercase m-2"
                  aria-label="link"
                >
                  Our beliefs
                </Link>
                <Link
                  to="/why-fluo"
                  className="cta text-uppercase m-2"
                  aria-label="link"
                >
                  Why Fluo Foundation?
                </Link>
                <Link
                  to="/stewardship"
                  className="cta text-uppercase m-2"
                  aria-label="link"
                >
                  Consciousness & Stewardship
                </Link>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  )
}
